import React, { Component } from "react";
import CartContext from "./CartContext";
import { SideMenu } from "./SideMenu";
import { BsFillPencilFill } from "react-icons/bs";
import { MessageBox } from "./MessageBox";
import { LoadSpinner } from "./LoadSpinner";
import axios from "axios";
import Fuse from "fuse.js";
import { Country, State, City } from "country-state-city";
import { BiSave, BiRefresh, BiUpload, BiDownload } from "react-icons/bi";

import {
  OverlayTrigger,
  Tooltip,
  Button,
  ButtonToolbar,
  Form,
  Row,
  Col,
  Modal,
  Nav,
  Table,
  Navbar,
  Stack,
  FormControl,
} from "react-bootstrap";

export class RawMaterialSuppliers extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      rawmaterialsuppliers: [],
      filteredRawmaterialsuppliers: [],
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      reload: true,
    };
    this.inputFile = React.createRef();
  }
  onSearchChange = (query) => {
    this.setState({ reload: false });
    this.setState({ searchquery: query });
    if (!query) {
      //this.setState({ searchData: [] });
      this.setState(
        { filteredRawmaterialsuppliers: this.state.rawmaterialsuppliers },
        () => {
          this.setState({ reload: true });
        }
      );
      return;
    }
    const fuse = new Fuse(this.state.rawmaterialsuppliers, {
      keys: ["name", "mobileNo", "city"],
      threshold: 0.2,
      ignoreLocation: true,
      findAllMatches: true,
      includeMatches: true,
      distance: 120,
    });
    const result = fuse.search(query);
    const finalResult = [];
    if (result.length) {
      result.forEach((item) => {
        finalResult.push(item.item);
      });
      this.setState(
        { filteredRawmaterialsuppliers: finalResult.slice(0, 15) },
        () => {
          this.setState({ reload: true });
        }
      );
    } else {
      this.setState({ filteredRawmaterialsuppliers: [] });
    }
  };

  GetRawMaterialSuppliers = () => {
    fetch(
      process.env.REACT_APP_API +
        "StoreManager/GetRawMaterialSuppliers/" +
        this.context.storeId
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          this.setState({ rawmaterialsuppliers: data }, () => {
            this.setState({ filteredRawmaterialsuppliers: data });
            this.setState({ reload: false }, () => {
              this.setState({ reload: true });
            });
          });
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
  };

  OnSaved = () => {
    this.OnRefreshButtonClick();
  };
  OnDeleted = () => {
    this.OnRefreshButtonClick();
  };

  OnRefreshButtonClick = () => {
    this.setState({ rawmaterialsuppliers: [] }, () => {
      this.GetRawMaterialSuppliers();
    });
  };
  ShowMessagBox = (title, message) => {
    this.setState({ msgboxOpen: true });
    this.setState({ msgboxTitle: title });
    this.setState({ msgboxMessage: message });
  };

  OnUpdated = (indexno) => {
    this.OnRefreshButtonClick();
  };

  addModalClose = () => {
    this.setState({ addModalShow: false }, () => {});
    this.OnRefreshButtonClick();
  };

  onUploadButtonClick = () => {
    this.inputFile.current.click();
  };

  handleFileUpload = (e) => {
    this.ShowLoadSpinner();
    const { files } = e.target;

    const reader = new FileReader();
    reader.onload = (e) => {
      const text = e.target.result;
      this.UploadProductsFromCSV(text);
    };
    reader.readAsText(files[0]);
  };

  UploadProductsFromCSV = (csvstr) => {
    this.ShowLoadSpinner();
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(csvstr),
    };

    fetch(
      process.env.REACT_APP_API +
        "Rawmaterials/UploadRawMaterialsFromCsv/" +
        this.context.storeId,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 404) {
          return;
        }
        this.OnRefreshButtonClick();
        this.HideLoadSpinner();
        this.ShowMessagBox(
          "Information",
          "Uploaded Successfully. Please Refresh(f5) the Portal! \r\n" +
            "\r\n" +
            data
        );
      })
      .catch((error) => {
        this.HideLoadSpinner();
        // this.ShowMessagBox("Failed", "Unable to Add! try later");
        alert("Failed - " + "Invalid CSV file format");
      });
  };
  DownloadProductsToCSV = () => {
    this.ShowLoadSpinner();
    var res = axios
      .get(
        process.env.REACT_APP_API +
          "Rawmaterials/DownloadRawMaterialsToCSV/" +
          this.context.storeId
      )
      .then((response) => {
        if (response.status === 200) {
          this.HideLoadSpinner();
          const element = document.createElement("a");
          const file = new Blob([response.data], {
            type: "text/plain",
          });
          element.href = URL.createObjectURL(file);
          element.download =
            "rawmaterial-" +
            new Date().getDate() +
            (new Date().getMonth() + 1) +
            new Date().getFullYear() +
            "-" +
            new Date().getMinutes() +
            new Date().getSeconds() +
            ".csv";
          document.body.appendChild(element); // Required for this to work in FireFox
          element.click();
        } else {
          this.HideLoadSpinner();
          this.ShowMessagBox("Error", "Download Failed. Please try later!");
        }
      })
      .catch((error) => {
        this.HideLoadSpinner();
        console.error("DownloadProductsToCSV - There was an error! ", error);
      });
  };

  componentDidMount = () => {
    if (this.state.rawmaterialsuppliers.length == 0)
      this.GetRawMaterialSuppliers();
    window.scrollTo(0, 0);

    document.addEventListener("keydown", (event) => {
      if (event.key == "F8") {
        this.setState({ addModalShow: true });
      } else if (event.key == "F9") {
        this.OnRefreshButtonClick();
      }
    });
  };

  render() {
    return (
      <>
        <div className="Container-fluid p-0 ">
          {this.state.msgboxOpen === true ? (
            <MessageBox
              open={this.state.msgboxOpen}
              title={this.state.msgboxTitle}
              message={this.state.msgboxMessage}
              callback={this.CloseMessagBoxCallback}
            />
          ) : (
            ""
          )}
          <Navbar className="shadow position-sticky fixed-top py-3 text-black ">
            <h4>
              <b>RawMaterial Suppliers</b>
            </h4>
            <Navbar.Collapse className="justify-content-end mx-0 ">
              <Nav>
                <ButtonToolbar className="text-end align-middle">
                  <Button
                    size="sm"
                    className="mainthemecolor"
                    // onClick={() => this.handleAddSupplier()}
                    onClick={() => this.setState({ addModalShow: true })}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-plus"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                    </svg>
                    &nbsp;Add (F8)
                  </Button>
                  &nbsp;
                  <Button
                    size="sm"
                    className="mainthemecolor"
                    size=""
                    onClick={() => this.OnRefreshButtonClick()}
                  >
                    <BiRefresh size="16"></BiRefresh>
                    &nbsp;Refresh (F9)
                  </Button>
                  &nbsp;
                  {this.state.addModalShow === true ? (
                    <SupplierAddOrEditModal
                      show={this.state.addModalShow}
                      Type="Add"
                      onHide={this.addModalClose}
                    />
                  ) : null}
                </ButtonToolbar>
                <Button
                  size="sm"
                  className="bg-warning text-dark "
                  // onClick={() => this.setState({ addModalShow: true })}
                  onClick={(e) => this.onUploadButtonClick()}
                  disabled
                >
                  <BiUpload
                    size="16"
                    className="bg-warning text-dark"
                  ></BiUpload>
                  &nbsp;Upload from CSV
                </Button>
                &nbsp;
                <Button
                  className="bg-warning text-dark "
                  size="sm"
                  onClick={(e) => this.DownloadProductsToCSV()}
                  disabled
                >
                  <BiDownload
                    size="16"
                    className="bg-warning text-dark"
                  ></BiDownload>
                  &nbsp;Download as CSV
                </Button>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
          <div className="purposestyle">
            <h6>
              <b>Purpose:</b> Use this module to Manage all Supplier
              informations who supply RawMaterials.
            </h6>
          </div>
          <div className="p-3">
            <div className=" mx-5 p-1">
              <Table className="mx-0 py-0" striped>
                <Row className="">
                  <Col>
                    <Stack direction="horizontal" gap={3} className="">
                      <b>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="30"
                          height="30"
                          fill="currentColor"
                          class="bi bi-search"
                          viewBox="0 0 16 16"
                        >
                          <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                        </svg>
                      </b>
                      <FormControl
                        type="search"
                        placeholder="Search by name, phoneno or city... "
                        className="text-dark fw-bold bg-white "
                        size="lg"
                        aria-label="Search"
                        onChange={(e) => this.onSearchChange(e.target.value)}
                      />
                    </Stack>
                  </Col>
                </Row>
              </Table>
            </div>
            <Table border striped className="px-0 bg-white ">
              <thead className="">
                <tr className="text-start text-black bg-white border">
                  <th>#</th>
                  <th width="15%">Supplier Name</th>
                  <th width="10%">MobileNo</th>
                  <th width="10%">Email-Id</th>
                  <th width="10%">City</th>
                  <th width="35%">Address</th>
                  <th width="20%" className="text-end">
                    Options
                  </th>
                </tr>
              </thead>
              <tbody className="text-primary border">
                {this.state.filteredRawmaterialsuppliers
                  .sort((a, b) => (a.created > b.created ? 1 : -1))
                  .map((supplier, i) =>
                    this.state.reload === true ? (
                      <EditSupplierInline
                        index={i}
                        supplier={supplier}
                        OnDeleted={this.OnDeleted}
                      ></EditSupplierInline>
                    ) : null
                  )}
              </tbody>
            </Table>
          </div>
        </div>
      </>
    );
  }
}

export class EditSupplierInline extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      supplier: "",
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      loadSpinnerOpen: false,
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      editModalShow: false,
    };
  }

  ShowMessagBox = (title, message) => {
    this.setState({ msgboxOpen: true });
    this.setState({ msgboxTitle: title });
    this.setState({ msgboxMessage: message });
  };
  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
  };

  ShowLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: true });
  };
  HideLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: false });
  };
  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
  };

  OnDelete = () => {
    if (this.state.supplier.id == undefined) {
      this.ShowMessagBox(
        "Information",
        "This is invalid row which can't be deleted. Press Refresh!"
      );
      return;
    }

    this.ShowLoadSpinner();
    const requestOptions = {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
    };

    fetch(
      process.env.REACT_APP_API +
        "StoreManager/DeleteRawMaterialSupplier/" +
        this.state.supplier.id,
      requestOptions
    )
      .then((res) => {
        if (res.status != 200) {
          this.HideLoadSpinner();
          alert(
            "Not deleted. This Supplier may be associated with few Products. First disassociate this supplier from the Products and then try!"
          );
          return;
        }
        this.HideLoadSpinner();
        this.ShowMessagBox(
          "Status",
          "Deleted Successfully. Click Refresh Button to see the changes!"
        );
        this.props.OnDeleted();
      })
      .catch((error) => {
        this.HideLoadSpinner();
        alert("OnDelete Failed" + error);
      });
  };

  componentDidMount = () => {
    this.setState({ supplier: this.props.supplier });
  };
  OnEditButtonClick = () => {
    this.setState({ editModalShow: true }, () => {});
  };

  editModalClose = () => {
    this.setState({ editModalShow: false }, () => {});
  };

  render() {
    return (
      <>
        {this.state.editModalShow === true ? (
          <SupplierAddOrEditModal
            show={this.state.editModalShow}
            onHide={this.editModalClose}
            supplier={this.state.supplier}
            Type="Edit"
          />
        ) : (
          ""
        )}
        {this.state.loadSpinnerOpen === true ? (
          <LoadSpinner open="true"></LoadSpinner>
        ) : (
          ""
        )}
        <tr
          className="text-start align-middle text-secondary bg-white mx-5"
          style={{ fontSize: "12px" }}
        >
          {this.state.msgboxOpen === true ? (
            <MessageBox
              open={this.state.msgboxOpen}
              title={this.state.msgboxTitle}
              message={this.state.msgboxMessage}
              callback={this.CloseMessagBoxCallback}
            />
          ) : (
            ""
          )}
          <td>{this.props.index + 1}</td>
          <td className="text-start ">{this.state.supplier.name}</td>

          <td className="text-start ">{this.state.supplier.mobileNo}</td>
          <td className="text-start ">{this.state.supplier.emailId}</td>
          <td className="text-start ">{this.state.supplier.city}</td>
          <td className="text-start ">
            {this.state.supplier.address +
              ", " +
              this.state.supplier.city +
              ", " +
              this.state.supplier.state +
              ", " +
              this.state.supplier.country +
              ", " +
              this.state.supplier.pinCode}
          </td>
          <td className="col-md-2 text-end align-middle ">
            <div class="btn-group">
              <OverlayTrigger overlay={<Tooltip>Edit!</Tooltip>}>
                <Button
                  className="rounded-circle"
                  size="sm"
                  variant="warning"
                  onClick={(e) => {
                    this.OnEditButtonClick(e);
                  }}
                >
                  <BsFillPencilFill size="16" />
                </Button>
              </OverlayTrigger>

              <OverlayTrigger
                overlay={
                  <Tooltip>
                    Warning! This will delete this Brand Row and associated
                    Products as well.
                  </Tooltip>
                }
              >
                <Button
                  className="mx-1 rounded-circle"
                  size="sm"
                  variant="danger"
                  onClick={(e) => {
                    if (
                      window.confirm(
                        "Warning! This action will delete this Brand Row and associated Products as well. Are you sure you want to Delete?"
                      )
                    ) {
                      this.OnDelete(e);
                    }
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-trash"
                    viewBox="0 0 16 16"
                  >
                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                    <path
                      fill-rule="evenodd"
                      d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                    />
                  </svg>
                </Button>
              </OverlayTrigger>
            </div>
          </td>
        </tr>
      </>
    );
  }
}

export class SupplierAddOrEditModal extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);

    this.state = {
      supplier: {
        supplierName: "",
        manufacturerName: "",
        imgFileName: "",
        hideMe: false,
      },
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      loadSpinnerOpen: false,
    };
  }

  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
    this.props.onHide();
  };
  ShowMessagBox = (title, message) => {
    this.setState({ msgboxOpen: true });
    this.setState({ msgboxTitle: title });
    this.setState({ msgboxMessage: message });
  };
  ShowLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: true });
  };
  HideLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: false });
  };

  AddOrUpdateSupplierInDB = () => {
    this.ShowLoadSpinner();

    var tmpSupplier = this.state.supplier;
    if (this.props.Type == "Edit") {
      tmpSupplier = this.props.supplier;
    } else {
      tmpSupplier.storeId = this.context.storeId;
    }
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(tmpSupplier),
    };

    fetch(
      process.env.REACT_APP_API +
        "StoreManager/AddOrUpdateRawMaterialSupplier/",
      requestOptions
    )
      .then((res) => {
        if (res.status == 200) {
          this.HideLoadSpinner();
          this.props.onHide();
          return;
        }
        this.HideLoadSpinner();
        alert("This Supplier is already exist. try again!");
        return;
      })
      .catch((error) => {
        this.HideLoadSpinner();
        alert("Exception. Received an Exception. Try after sometime !" + error);
      });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.AddOrUpdateSupplierInDB();
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;

    switch (name.trim()) {
      case "name":
        this.state.supplier.name = value;
        break;
      case "address":
        this.state.supplier.address = value;
        break;
      case "city":
        this.state.supplier.city = value;
        break;
      case "state":
        this.state.supplier.state = value;
        break;
      case "country":
        this.state.supplier.country = value;
        break;
      case "pinCode":
        this.state.supplier.pinCode = value;
        break;
      case "mobileNo":
        if (Number.isInteger(Number(value)))
          this.state.supplier.mobileNo = value;
        break;
      case "emailId":
        this.state.supplier.emailId = value;
        break;
      case "companyName":
        this.state.supplier.companyName = value;
        break;
      case "gstNo":
        this.state.supplier.gstNo = value;
        break;
      case "accountDetails":
        this.state.supplier.accountDetails = value;
        break;
    }
    this.setState({ supplier: this.state.supplier });
  };

  componentDidMount() {
    if (this.props.Type == "Edit") {
      this.setState({ supplier: this.props.supplier });
    }
  }

  render() {
    return (
      <div className="container ">
        <Modal
          {...this.props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          backdrop="static"
          keyboard={false}
          dialogClassName="SupplierModal"
        >
          {this.state.msgboxOpen === true ? (
            <MessageBox
              open={this.state.msgboxOpen}
              title={this.state.msgboxTitle}
              message={this.state.msgboxMessage}
              callback={this.CloseMessagBoxCallback}
            />
          ) : (
            ""
          )}
          {this.state.loadSpinnerOpen === true ? (
            <LoadSpinner open="true"></LoadSpinner>
          ) : (
            ""
          )}
          <Form onSubmit={this.handleSubmit}>
            <Modal.Header closeButton className="bg-warning">
              <Modal.Title id="contained-modal-title-vcenter">
                {this.props.Type == "Edit" ? "Edit Supplier" : "Add Supplier"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="show-grid ">
              <Row className="m-2 p-2 " style={{ fontSize: "12pt" }}>
                <Col md={12}>
                  <Form.Group as={Row} className="mb-1" controlId="">
                    <Form.Label column sm="3">
                      Supplier Name *
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        type="text"
                        name="name"
                        maxlength="99"
                        value={this.state.supplier.name}
                        required
                        focus
                        autoFocus
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-1" controlId="">
                    <Form.Label column sm="3">
                      Address
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        type="text"
                        name="address"
                        maxlength="254"
                        value={this.state.supplier.address}
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-1" controlId="">
                    <Form.Label column sm="3">
                      City *
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        type="text"
                        name="city"
                        maxlength="49"
                        required
                        value={this.state.supplier.city}
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-1" controlId="">
                    <Form.Label column sm="3">
                      Country *
                    </Form.Label>
                    <Col sm="9">
                      <Form.Select
                        type="text"
                        name="country"
                        value={this.state.supplier.country}
                        required
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      >
                        <option value=""></option>
                        {Country.getAllCountries().map((country) => (
                          <>
                            <option value={country.isoCode}>
                              {country.name}
                            </option>
                          </>
                        ))}
                      </Form.Select>
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-1" controlId="">
                    <Form.Label column sm="3">
                      State *
                    </Form.Label>
                    <Col sm="9">
                      <Form.Select
                        type="text"
                        name="state"
                        value={this.state.supplier.state}
                        required
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      >
                        <option value=""></option>
                        {State.getStatesOfCountry(
                          this.state.supplier.country
                        ).map((s1) => (
                          <>
                            <option>{s1.name}</option>
                          </>
                        ))}
                      </Form.Select>
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-1" controlId="">
                    <Form.Label column sm="3">
                      PinCode
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        type="text"
                        name="pinCode"
                        maxlength="9"
                        value={this.state.supplier.pinCode}
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-1" controlId="">
                    <Form.Label column sm="3">
                      Mobile No *
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        type="text"
                        name="mobileNo"
                        maxlength="10"
                        required
                        value={this.state.supplier.mobileNo}
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-1" controlId="">
                    <Form.Label column sm="3">
                      Email Id
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        type="email"
                        name="emailId"
                        maxlength="99"
                        value={this.state.supplier.emailId}
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-1" controlId="">
                    <Form.Label column sm="3">
                      Business Full Name
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        type="text"
                        name="companyName"
                        maxlength="99"
                        value={this.state.supplier.companyName}
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-1" controlId="">
                    <Form.Label column sm="3">
                      GSTIN
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        type="text"
                        name="gstNo"
                        maxlength="49"
                        value={this.state.supplier.gstNo}
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-1" controlId="">
                    <Form.Label column sm="3">
                      Bank Account Details
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        type="text"
                        name="accountDetails"
                        maxlength="639"
                        value={this.state.supplier.accountDetails}
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer className="bg-light">
              <Form.Group>
                <Button variant="primary" type="submit">
                  Save
                </Button>
              </Form.Group>

              <Button variant="danger" onClick={this.props.onHide}>
                Close
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      </div>
    );
  }
}
